webpackJsonp([70144966829960],{

/***/ 204:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(19);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Contact = function Contact() {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_reactHelmet2.default, {
	      title: 'Contact | Cory Schadt',
	      bodyAttributes: {
	        class: 'inner'
	      }
	    }),
	    _react2.default.createElement(
	      'div',
	      { className: 'page fade' },
	      _react2.default.createElement(
	        'div',
	        { className: 'container' },
	        _react2.default.createElement(
	          'div',
	          { className: 'content' },
	          _react2.default.createElement(
	            'h1',
	            null,
	            'Contact'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'text' },
	            _react2.default.createElement(
	              'p',
	              null,
	              'Email: ',
	              _react2.default.createElement(
	                'a',
	                { href: 'mailto:coryschadt@gmail.com' },
	                'coryschadt@gmail.com'
	              )
	            )
	          )
	        )
	      )
	    )
	  );
	};
	exports.default = Contact;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-contact-js-b63be7128a741224b0b8.js